module.exports = __webpack_public_path__ + "static/img/item14@2x.1955173b.png";